module.exports = __webpack_public_path__ + "media/images/icon__predict@3x-13cc316bdb58fcee17bfadd8b3751227.png";